import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ASSETS, CTA_URL } from "@/lib/config";
import { trackClick } from "@/lib/tracker";

export default function Footer() {
    const year = 2026;
    const onCta = () => {
        trackClick("dapatkan-superzone-footer", "DAPATKAN SUPERZONE");
    };
    return (
        <footer
            data-testid="footer-section"
            className="relative bg-[#060614] text-[#FAF9F6] overflow-hidden"
        >
            <div className="absolute inset-0 bg-grid opacity-30" />
            <div
                className="blob"
                style={{ background: "#0044FE", width: 500, height: 500, top: "-20%", right: "-10%" }}
            />

            <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-10 pt-20 md:pt-28 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
                    <div className="md:col-span-8">
                        <motion.h3
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="font-display uppercase text-[7vw] sm:text-[5vw] md:text-[3vw] leading-[1.05] text-center md:text-left"
                        >
                            "Trade yang terbaik bukan yang paling banyak, tetapi yang{" "}
                            <span style={{ color: "#ED1C24" }}>paling berkualiti</span>."
                        </motion.h3>
                    </div>
                    <div className="md:col-span-4 flex justify-center md:justify-end">
                        <a
                            href={CTA_URL}
                            onClick={onCta}
                            className="cta-primary text-sm md:text-base"
                            data-testid="footer-cta-button"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            DAPATKAN SUPERZONE
                            <ArrowUpRight className="w-5 h-5" strokeWidth={3} />
                        </a>
                    </div>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-center border-t border-white/15 pt-8">
                    <div className="md:col-span-6 flex flex-col md:flex-row items-center md:items-center md:justify-start gap-3 text-center md:text-left">
                        <img
                            src={ASSETS.logo}
                            alt="CIKO"
                            className="h-11 w-11 rounded-full ring-2 ring-white/60"
                        />
                        <div>
                            <div className="font-display text-lg">CIKO</div>
                            <div className="text-[10px] tracking-[0.24em] text-white/60">
                                SUPER SCALPER
                            </div>
                        </div>
                    </div>
                    <div
                        className="md:col-span-6 text-center md:text-right text-xs font-mono-tight uppercase tracking-widest text-white/60"
                        data-testid="footer-copyright"
                    >
                        © {year} CIKO. All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
}
